import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'carto',
      component: () => import('@/views/CartoView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPasswordView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/ResetPasswordView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/recensement',
      name: 'recensement',
      component: () => import('@/views/RecensementView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/recensement/admin',
      name: 'recensement-admin',
      component: () => import('@/views/RecensementAdminView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    // Routes d'administration
    {
      path: '/admin',
      name: 'admin',
      component: () => import('@/views/admin/AdminDashboard.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/users',
      name: 'admin-users',
      component: () => import('@/views/admin/AdminUsers.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/modules',
      name: 'admin-modules',
      component: () => import('@/views/admin/AdminModules.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/couches',
      name: 'admin-couches',
      component: () => import('@/views/admin/AdminCouches.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/tickets',
      name: 'admin-tickets',
      component: () => import('@/views/admin/AdminTickets.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/streetview',
      name: 'admin-streetview',
      component: () => import('@/views/admin/AdminStreetView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, requiresSuperAdmin: true }
    },
    {
      path: '/admin/donnees',
      name: 'admin-donnees',
      component: () => import('@/views/admin/AdminDonnees.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    // Module Mobilier Urbain
    {
      path: '/mobilier',
      name: 'mobilier',
      component: () => import('@/views/MobilierView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/mobilier/admin',
      name: 'mobilier-admin',
      component: () => import('@/views/MobilierAdminView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    // Module Missions DST
    {
      path: '/missions-dst',
      name: 'missions-dst',
      component: () => import('@/views/CantonnierView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/missions-dst/admin',
      name: 'missions-dst-admin',
      component: () => import('@/views/CantonnierAdminView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/missions-dst/admin/creer',
      name: 'missions-dst-creer',
      component: () => import('@/views/CantonnierCreerView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/missions-dst/admin/parcours',
      name: 'missions-dst-parcours',
      component: () => import('@/views/CantonnierParcoursView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  // Vérifier l'authentification
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  
  // Vérifier les droits admin
  if (to.meta.requiresAdmin) {
    const userRole = authStore.user?.role
    if (userRole !== 'admin' && userRole !== 'superadmin') {
      next({ name: 'carto' })
      return
    }
  }
  
  // Vérifier les droits superadmin
  if (to.meta.requiresSuperAdmin && authStore.user?.role !== 'superadmin') {
    next({ name: 'admin' })
    return
  }
  
  next()
})

export default router
